type Translate = (key: string, defaultValue?: string) => string;

export const menuAddOnDefaultText = {
  menuTitle: {
    key: 'app.menu-add-on.defaults.menu-title',
    fallback: 'Our Specialties',
  },
  menuSubtitle: {
    key: 'app.menu-add-on.defaults.menu-subtitle',
    fallback: 'A closer look at some of our dishes.',
  },
  viewFullMenuButton: {
    key: 'app.menu-add-on.defaults.view-full-menu-button',
    fallback: 'View Full Menu',
  },
  addToCartButton: {
    key: 'app.menu-add-on.defaults.add-to-cart-button',
    fallback: 'Add to Cart',
  },
} as const;

export const getMenuAddOnDefaultText = (field: keyof typeof menuAddOnDefaultText, t: Translate) => {
  const text = menuAddOnDefaultText[field];
  return t(text.key, text.fallback);
};
